var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGhs = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_15537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12.2677C0 13.7355 0.264047 15.1416 0.746391 16.4416L12 16.9633L23.2536 16.4416C23.736 15.1416 24 13.7355 24 12.2677C24 10.7998 23.736 9.39377 23.2536 8.09379L12 7.57202L0.746391 8.09374C0.264047 9.39377 0 10.7998 0 12.2677Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 0.267334C6.84012 0.267334 2.44161 3.52383 0.746094 8.09344H23.2534C21.5578 3.52383 17.1593 0.267334 11.9997 0.267334Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2533 16.4392H0.746094C2.44161 21.0088 6.84013 24.2653 11.9997 24.2653C17.1593 24.2653 21.5578 21.0088 23.2533 16.4392Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8.09546L13.0359 11.2839H16.3888L13.6764 13.2547L14.7124 16.4432L12 14.4726L9.28753 16.4432L10.3237 13.2547L7.61133 11.2839H10.964L12 8.09546Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_15537"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGhs);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/GHS.6c06db21d141d544dfdd278a7a3eeca4.svg";